<script lang="ts">
  import { auth } from '$lib/stores/auth.svelte';
  import { goto } from '$app/navigation';

  let { children } = $props();
  if (!auth.user?.role.includes('admin')) {
    goto('/', {replaceState: true});
  }
</script>

{@render children?.()}
